/**
 * @desc 完成任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.ActivitiTaskInfoDto>>;
export function request(
  body: defs.activiti.BpmActivitiCompleteBusinessDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/completeTaskGetInfoRouteBpm`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
